<po-page-default [p-actions]="pageActions">

  <!-- Período, área e usuário são um recorte só, então dividem a mesma po-row.
       As larguras saem do grid do PO (po-md-*/po-lg-*), sem layout próprio. -->
  <div class="po-row">
    <!-- Mesmo seletor da fila e das estatísticas de curadoria. `inline` porque aqui ele
         divide a linha com os outros filtros, em vez de abrir uma linha só sua; as
         classes de grid são as que este recorte precisa para os cinco campos caberem. -->
    <app-period-filter
      [inline]="true"
      rangeClass="po-sm-12 po-md-8 po-lg-4"
      [period]="period"
      (periodChange)="onPeriodChange($event)">
    </app-period-filter>

    <!-- (ngModelChange), não (p-change): o po-multiselect emite em p-change os
         OBJETOS de opção inteiros ({value, label}), não os valores. (ngModelChange)
         já vem filtrado para o array de valores puros pelo próprio ControlValueAccessor
         do PO — é o mesmo motivo por trás do po-select do período logo acima.

         `p-filter-mode="contains"`: o padrão do PO é `startsWith`, que só acha quem
         souber como o nome COMEÇA. Nome de área e de usuário são compostos ("Engenharia
         de Entrada", "Ana Paula Souza") e o que se lembra costuma estar no meio — com o
         padrão, digitar "entrada" não traz nada e o campo parece vazio. -->
    <po-multiselect
      name="costsArea"
      class="po-sm-12 po-md-4 po-lg-3"
      p-label="Área"
      p-placeholder="Todas as áreas"
      p-filter-mode="contains"
      [p-options]="areaOptions"
      [ngModel]="selectedAreas"
      (ngModelChange)="onAreaChange($event)">
    </po-multiselect>

    <po-multiselect
      name="costsUser"
      class="po-sm-12 po-md-4 po-lg-3"
      p-label="Usuário"
      p-placeholder="Todos os usuários"
      p-filter-mode="contains"
      [p-options]="userOptions"
      [ngModel]="selectedUsers"
      (ngModelChange)="onUserChange($event)">
    </po-multiselect>

    <po-multiselect
      name="costsResourceType"
      class="po-sm-12 po-md-4 po-lg-3"
      p-label="Tipo de review"
      p-placeholder="Todos os tipos"
      p-filter-mode="contains"
      [p-options]="resourceTypeOptions"
      [ngModel]="selectedResourceTypes"
      (ngModelChange)="onResourceTypeChange($event)">
    </po-multiselect>

    <po-multiselect
      name="costsSourceProvider"
      class="po-sm-12 po-md-4 po-lg-3"
      p-label="Origem"
      p-placeholder="Todas as origens"
      p-filter-mode="contains"
      [p-options]="sourceProviderOptions"
      [ngModel]="selectedSourceProviders"
      (ngModelChange)="onSourceProviderChange($event)">
    </po-multiselect>
  </div>

  <!-- Filtros ativos como disclaimers: é o componente do PO para isso, e cada chip
       remove o próprio filtro sem precisar reabrir o campo. -->
  <po-disclaimer-group
    *ngIf="disclaimers.length"
    p-title="Filtros aplicados"
    [p-disclaimers]="disclaimers"
    (p-remove)="onDisclaimerRemove($event)"
    (p-remove-all)="onDisclaimersRemoveAll()">
  </po-disclaimer-group>

  <po-loading-overlay *ngIf="loading" p-size="md" p-text="Carregando"></po-loading-overlay>

  <ng-container *ngIf="!loading">

    <app-costs-kpis [summary]="summary" [previous]="previousSummary"></app-costs-kpis>

    <div class="po-row">
      <po-widget class="po-md-12" p-title="Evolução do custo por dia">
        <app-costs-timeseries-chart
          [points]="points"
          [currency]="currency"
          [period]="period">
        </app-costs-timeseries-chart>
      </po-widget>
    </div>

    <!-- Origem e tipos lado a lado: pouca cardinalidade, leitura de distribuição e ação
         direta sobre onde o custo nasce. -->
    <div class="po-row">
      <po-widget class="po-md-4" p-title="Custo por origem">
        <app-costs-breakdown-section
          keyLabel="Origem"
          [rows]="sourceProviderRows"
          [currency]="currency"
          [totalKeys]="keysOf('sourceProvider')"
          [period]="period">
        </app-costs-breakdown-section>
      </po-widget>

      <po-widget class="po-md-4" p-title="Custo por tipo de review">
        <app-costs-breakdown-section
          keyLabel="Tipo de review"
          [rows]="resourceTypeRows"
          [currency]="currency"
          [totalKeys]="resourceTypeKeys"
          [period]="period">
        </app-costs-breakdown-section>
      </po-widget>

      <po-widget class="po-md-4" p-title="Custo por tipo de análise">
        <app-costs-breakdown-section
          keyLabel="Tipo de análise"
          [rows]="promptTypeRows"
          [currency]="currency"
          [totalKeys]="keysOf('promptType')"
          [period]="period">
        </app-costs-breakdown-section>
      </po-widget>
    </div>

    <div class="po-row">
      <po-widget class="po-md-6" p-title="Custo por área">
        <po-info
          *ngIf="biggestAreaIncreaseLabel as biggest"
          p-label="Maior alta"
          [p-value]="biggest + ' vs. período anterior'"
          p-orientation="horizontal">
        </po-info>
        <app-costs-breakdown-section
          keyLabel="Área"
          [rows]="areaRows"
          [currency]="currency"
          [totalKeys]="keysOf('area')"
          [period]="period">
        </app-costs-breakdown-section>
      </po-widget>

      <po-widget class="po-md-6" p-title="Custo por usuário">
        <app-costs-breakdown-section
          keyLabel="Usuário"
          [rows]="userRows"
          [currency]="currency"
          [totalKeys]="keysOf('user')"
          [period]="period">
        </app-costs-breakdown-section>
      </po-widget>
    </div>

    <div class="po-row">
      <po-widget class="po-md-12" p-title="Custo por review">
        <!-- A frase sobre reprocessamento viaja com a dimensão até o modal, onde a
             coluna Execuções existe. Aqui no card só há barras de custo: explicar uma
             coluna que não está à vista era pedir para o texto ser pulado. -->
        <app-costs-breakdown-section
          keyLabel="Review"
          [rows]="resourceRows"
          [currency]="currency"
          [totalKeys]="keysOf('resource')"
          [period]="period"
          readingNote="Cada arquivo gera uma execução em cada tipo de análise. Reprocessar gera execuções novas — quanto mais Execuções por Fonte, mais o review foi reprocessado."
          [splitResource]="true">
        </app-costs-breakdown-section>
      </po-widget>
    </div>

    <!-- Por último de propósito: modelo e linguagem explicam composição do custo, mas
         são menos acionáveis que Área/Usuário/Review. Dividem a linha por terem a mesma
         natureza: poucas chaves e leitura de distribuição. -->
    <div class="po-row">
      <!-- Entendimento Técnico fica fora deste recorte no backend: é outro tipo de
           análise, não revisão de código por arquivo, e o custo dele está em "Custo por
           tipo de análise". -->
      <po-widget class="po-md-6" p-title="Custo por linguagem (code review)">
        <app-costs-breakdown-section
          keyLabel="Linguagem"
          [rows]="languageRows"
          [currency]="currency"
          [totalKeys]="keysOf('language')"
          [period]="period"
          readingNote="Entendimento Técnico não entra: é outro tipo de análise, não revisão de código por arquivo. O custo dele está em Custo por tipo de análise.">
        </app-costs-breakdown-section>
      </po-widget>

      <po-widget class="po-md-6" p-title="Custo por modelo">
        <app-costs-breakdown-section
          keyLabel="Modelo"
          [rows]="modelRows"
          [currency]="currency"
          [totalKeys]="keysOf('model')"
          [period]="period">
        </app-costs-breakdown-section>
      </po-widget>
    </div>

  </ng-container>

</po-page-default>

<notificationComponentHM></notificationComponentHM>
